import {createAction} from 'redux-actions';

// unique key namespace used by combineReducers.
// By convention it will match the directory structure to
// make it easy to locate the src.
// Also action types will prefix with the capitalized version
export const key = 'auth';

// action type constants
export const authLogin = createAction(`${key}/LOGIN`,
  (login, origin, password, cb_success) => ({
    login,
    origin,
    password,
    cb_success,
  })
);

export const authLogout = createAction(`${key}/LOGOUT`,
  (cb_success) => ({
    cb_success
  })
);

export const authLogoutError = createAction(`${key}/LOGOUT_ERROR`,
  (err) => ({
    err,
    error: true
  })
);

export const authLoginError = createAction(`${key}/LOGIN_ERROR`,
  (err) => ({
    err,
    error: true
  })
);

export const authLogoutSuccess = createAction(`${key}/LOGOUT_SUCCESS`,
  (cb_success) => ({
    cb_success
  })
);

export const authLoginSuccess = createAction(`${key}/LOGIN_SUCCESS`,
  (user, cb_success) => ({
    user,
    cb_success,
  })
);

export const authRefreshSession = createAction(`${key}/REFRESH_SESSION`);

export const authResetStorage = createAction(`${key}/RESET_STORAGE`, (callback) => ({
    callback
  })
);

export default {
  authLogin,
  authLogout,
  authLoginError,
  authLogoutError,
  authLoginSuccess,
  authLogoutSuccess,
  authRefreshSession,
  authResetStorage
};



// WEBPACK FOOTER //
// ./src/util/redux/auth/actions.js